/**
 * Created by vladislav on 18.03.2021
 */

const SlotMachineReelView = cc.ClippingNode.extend({ 
    ctor: function (reel) {
        this._super();

        this.reel = reel;

        this.setClippingEnabled(true);

        const styles = cleverapps.styles.SlotMachineReelView;

        this.setContentSize2(styles);

        this.reel.symbols.forEach((symbol) => {
            this.addChild(new SlotMachineSymbolView(symbol));
        });
    }
});

cleverapps.styles.SlotMachineReelView = {
    width: 140,
    height: 286
};